import { Card, CardContent, CardHeader, withStyles } from "@material-ui/core";
import React, { useState } from "react";
import { FakeContent } from "../../shared/components";
import {
  FAIXA_ACEITE,
  getStyleConsumoOcorrido,
} from "../fechamentoConsumoUtils";
import { ConsumoInfo } from "./consumoInfo";
import MensagemConsumoNaoDisponivel from "./mensagemConsumoNaoDisponivel";
import { SubHeader } from "./subHeader";
import { t } from "adapters/i18n";

function estiloDoBotao(ativo) {
  return {
    color: ativo ? "#307297" : "#9E9E9E",
    backgroundColor: ativo ? "#ffffff" : "#F1F2F4",
    fontWeight: ativo ? "700" : "400",
  };
}

export const FechamentoConsumoCard = (props) => {
  const {
    classes,
    consumoFormula,
    index,
    faixaAceite,
    dadosCarregados,
    exibirFechamentoConsumo100kgPv,
  } = props;

  const [visualizacao, setVisualizacao] = useState("g/cab/dia");

  const {
    ConsumoOcorrido,
    ConsumoObjetivo,
    ConsumoObjetivo100KgPv,
    ConsumoOcorrido100KgPv,
  } = consumoFormula;
  const {
    cardFormula,
    cardHeader,
    cardContent,
    fontBold,
    valorConsumo,
    tooltipStyle,
    toggleButtons,
    toggleButton,
  } = classes;
  const inlineStyleConsumoOcorrido = getStyleConsumoOcorrido(
    ConsumoOcorrido,
    ConsumoObjetivo,
    FAIXA_ACEITE
  );

  const alterarVisualizacao = (novaVisualizacao) => {
    if (novaVisualizacao !== null) {
      setVisualizacao(novaVisualizacao);
    }
  };

  let gramaCabecaDia = visualizacao === "g/cab/dia";

  return (
    <Card className={cardFormula} data-testid="FechamentoConsumoCard" key={`consumoFormula-${index}`}>
      {exibirFechamentoConsumo100kgPv && (
        <div className={toggleButtons}>
          <button
            className={toggleButton}
            style={estiloDoBotao(gramaCabecaDia)}
            onClick={() => alterarVisualizacao("g/cab/dia")}
          >
            {t("common:measure.raw.g-h-day")}
          </button>
          <button
            className={toggleButton}
            style={estiloDoBotao(!gramaCabecaDia)}
            onClick={() => alterarVisualizacao("g/100kgPV/dia")}
          >
            {t("common:measure.raw.g-100kg-lw-day")}{" "}
          </button>
        </div>
      )}

      <CardHeader
        id={`headerCardFechamento-${index}`}
        className={cardHeader}
        title={
          <FakeContent
            showContent={dadosCarregados}
            content={consumoFormula.NomeFormula}
            height={20}
            width="30%"
          />
        }
        titleTypographyProps={{
          variant: "button",
          className: fontBold,
        }}
        subheader={
          <SubHeader
            consumoFormula={consumoFormula}
            showContent={dadosCarregados}
            visualizacao={visualizacao}
            temConsumoObjetivo100KgPv={!!ConsumoObjetivo100KgPv}
          />
        }
      />
      <CardContent className={cardContent}>
        {!gramaCabecaDia && !ConsumoObjetivo100KgPv ? (
          <MensagemConsumoNaoDisponivel data-testid="MensagemConsumoNaoDisponivel" />
        ) : (
          <ConsumoInfo
            dadosCarregados={dadosCarregados}
            faixaAceite={faixaAceite}
            ConsumoObjetivo={ConsumoObjetivo}
            ConsumoOcorrido={ConsumoOcorrido}
            ConsumoObjetivo100KgPv={ConsumoObjetivo100KgPv}
            valorConsumo={valorConsumo}
            index={index}
            tooltipStyle={tooltipStyle}
            inlineStyleConsumoOcorrido={inlineStyleConsumoOcorrido}
            consumoFormula={consumoFormula}
            gramaCabecaDia={gramaCabecaDia}
            ConsumoOcorrido100KgPv={ConsumoOcorrido100KgPv}
          />
        )}
      </CardContent>
    </Card>
  );
};

var styles = () => {
  const animationFade = {
    animationName: "fadeInOpacity",
    animationIterationCount: 1,
    animationTimingFunction: "ease-in",
  };
  return {
    tooltipStyle: {
      cursor: "pointer",
    },
    cardFormula: {
      width: 384,
      minHeight: 270,
      margin: "1px 15px 15px 0",
      borderStyle: "solid",
      borderWidth: "1px 1px 0 1px",
      borderColor: "#bbb",
      borderRadius: 2,
    },
    "@keyframes fadeInOpacity": {
      "0%": {
        opacity: 0,
      },
      "100%": {
        opacity: 1,
      },
    },
    cardHeader: {
      paddingBottom: 10,
      ...animationFade,
      animationDuration: "0.3s",
    },
    cardContent: {
      padding: "0 16px",
      margin: 0,
      ...animationFade,
      animationDuration: "0.5s",
    },
    fontBold: {
      fontWeight: "bold",
    },
    valorConsumo: {
      paddingLeft: 2,
      display: "inline",
    },
    toggleButtons: {
      backgroundColor: "#F1F2F4",
      margin: 16,
      padding: 8,
      borderRadius: 8,
      display: "flex",
      justifyContent: "center",
    },
    toggleButton: {
      flex: 1,
      padding: 4,
      borderRadius: 8,
      cursor: "pointer",
      border: "none",
      color: "#9E9E9E",
    },
    textoCinza: {
      color: "#616161",
      fontFamily: "Roboto",
    },
  };
};

export default React.memo(
  withStyles(styles)(FechamentoConsumoCard),
  (prevProps, nextProps) => {
    return prevProps.consumoFormula === nextProps.consumoFormula;
  }
);
